export default function StarRating({ rating = 0, totalReviews, size = 14, showCount = true }) {
  const rounded = Math.round(rating * 2) / 2; // nearest 0.5
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <div style={{ display: 'flex', gap: '1px' }}>
        {[1, 2, 3, 4, 5].map((s) => {
          const filled = s <= Math.floor(rounded);
          const half = !filled && s - 0.5 === rounded;
          return (
            <span
              key={s}
              style={{
                fontSize: size,
                color: filled || half ? '#f59e0b' : '#d4d0ea',
                lineHeight: 1,
                display: 'inline-block',
                background: half
                  ? 'linear-gradient(90deg, #f59e0b 50%, #d4d0ea 50%)'
                  : 'none',
                WebkitBackgroundClip: half ? 'text' : 'unset',
                WebkitTextFillColor: half ? 'transparent' : 'unset',
              }}
            >
              ★
            </span>
          );
        })}
      </div>
      {rating > 0 && (
        <span style={{ fontSize: size - 2, fontWeight: 600, color: '#f59e0b' }}>
          {rating.toFixed(1)}
        </span>
      )}
      {showCount && totalReviews !== undefined && (
        <span style={{ fontSize: size - 2, color: 'var(--text-3)' }}>
          ({totalReviews})
        </span>
      )}
    </div>
  );
}
